import { AbstractControl } from '@angular/forms';

export const VALIDATOR_ERRORS = {
    DATE_FORMAT: { key: 'dateFormat', text: 'Födelsedatumet måste följa formatet YYYYMMDD eller YYMMDD' },
    DATE_FORWARD: { key: 'dateForward', text: 'Datumet måste vara dagens datum eller tidigare' },
    DATE_INCORECT: { key: 'dateIncorect', text: 'Fältet måste innehålla ett datum' },
    EMAIL: { key: 'email', text: 'Epostadress måste vara en giltig epostadress' },
    PHONE_CHARS: { key: 'phoneChars', text: 'Tillåtna tecken är 0-9, + och -' },
    PHONE_LENGTH: { key: 'phoneLength', text: 'Telefonnummer måste vara maximalt 20 tecken' },
    QUALIFICATIONS: {
        key: 'qualifications',
        text: 'För att kunna slutföra dina ansökan behöver du ange vilka behörigheter som du vill utöka din legitimation med.'
            + ' Detta gör du under sidorna Speciallärare, Yrkesämnen, och Övriga behörigheter  i ansökan.',
    },
    REQUIRED: { key: 'required', text: 'Fältet är obligatoriskt' },
    SSN_CAPITAL_X: { key: 'ssnCapitalX', text: 'Om ditt personnummer innehåller ett X måste det skrivas med stor bokstav' },
    SSN_CHARS: { key: 'ssnChars', text: 'Personnummer får bara innehålla siffror' },
    SSN_CHECK: { key: 'ssnCheck', text: 'Personnumret är ej giltigt' },
    SSN_FORMAT: {
        key: 'ssnFormat',
        text: 'Personnumret måste följa något av följande format: YYYYMMDDNNNN/YYMMDDNNNN/YYYYMMDD-NNNN/YYMMDD-NNNN',
    },
    SSN_LENGTH: { key: 'ssnLength', text: 'Personnummer måste vara 12 siffor utan bindestreck' },
    SUPPLEMENT: { key: 'supplement', text: 'Bifoga minst en bilaga eller ange övrig information.' },
};

function toText(key: string): string {
    return Object.values(VALIDATOR_ERRORS)
        .filter((error) => key === error.key)
        .map((error) => error.text)
        .pop();
}

export function getErrorText(control: AbstractControl): string {
    if (control.valid || control.untouched || !control.errors) {
        return null;
    }
    const errors = control.errors;
    return Object.keys(errors)
        .filter((key) => errors[key])
        .map((key) => toText(key))
        .pop();
}
